import { gql } from '@apollo/client';
import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { ClaimCodeTable_ClaimCodeFragment } from '../__generated__/ClaimCodeTable.graphql';

export function CodeNameCell({
  value,
}: PropsWithChildren<CellProps<ClaimCodeTable_ClaimCodeFragment, string>>) {
  return (
    <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontWeight="semibold">
      {value}
    </Box>
  );
}

CodeNameCell.graphql = {
  fragments: {
    CodeNameCell_claimCode: gql`
      fragment CodeNameCell_claimCode on MultiClaimCodeDocument {
        id
        name
      }
    `,
  },
};
